// Utility functions for Electron compatibility

// Check if running in Electron
export const isElectron = () => {
  return window && window.process && window.process.type;
};

// Get base path for routing
export const getBasePath = () => {
  if (isElectron()) {
    return './';
  }
  return process.env.PUBLIC_URL || '/';
};

// Fix asset paths for Electron
export const fixAssetPath = (path) => {
  if (isElectron() && path.startsWith('/')) {
    return '.' + path;
  }
  return path;
};

// Handle navigation for Electron
export const navigateInElectron = (path, navigate) => {
  if (isElectron()) {
    // Use relative path in Electron
    navigate(path.replace(/^\//, ''));
  } else {
    navigate(path);
  }
};

// Fix image sources for Electron
export const fixImageSource = (src) => {
  if (isElectron() && src.startsWith('/')) {
    return '.' + src;
  }
  return src;
};

// Fix CSS background images for Electron
export const fixCSSBackground = (url) => {
  if (isElectron() && url.startsWith('/')) {
    return `url('.${url}')`;
  }
  return `url('${url}')`;
};

// Apply Electron-specific styles
export const applyElectronStyles = () => {
  if (isElectron()) {
    // Add Electron-specific CSS variables
    document.documentElement.style.setProperty('--base-path', './');
    
    // Fix any absolute paths in CSS
    const styleSheets = document.styleSheets;
    for (let i = 0; i < styleSheets.length; i++) {
      try {
        const rules = styleSheets[i].cssRules || styleSheets[i].rules;
        for (let j = 0; j < rules.length; j++) {
          const rule = rules[j];
          if (rule.style && rule.style.backgroundImage) {
            const bgImage = rule.style.backgroundImage;
            if (bgImage.includes('url("/')) {
              rule.style.backgroundImage = bgImage.replace('url("/', 'url("./');
            }
          }
        }
      } catch (e) {
        // Cross-origin stylesheets will throw an error
        continue;
      }
    }
  }
}; 